
import { mapState } from 'vuex'
export default {
    props: {
        conData: {
            type: [String, Object, Array],
        },
    },
    data() {
        return {
            componentKey: 0,
            content: '',
            // isLimited: false,   // 제한일자 구분 변수
        }
    },
    computed: {
        ...mapState ({
            MEMBER_INFO : state => state.member.memberInfo,
        }),
    }, 
    watch: {
        conData() {
            // 플리커링 때문에 임시 주석 처리
            this.contentDfilter()
            // this.forceRerender()
        },
    },
    methods: {
        // 하위 컴포넌트 렌더링 문제
        forceRerender() {
            this.componentKey += 1
        },

        // 22.11.04 suye 수정 
        // 22.04.15 suye 기간제한일자 반환 함수: 오늘일자 - num => 기준일자 
        limitDateMaker(num){
            // 현재일자  
            const today = new Date();
            const year = today.getFullYear();
            const month = ('0' + (today.getMonth() + 1)).slice(-2);
            const day = ('0' + today.getDate()).slice(-2);

            // 현재일자 기준 -n일
            const dateLimit = new Date(year, Number(month)-1, day) 

            dateLimit.setDate(dateLimit.getDate() - num)

            // let limited = dateLimit.toLocaleDateString().replace(/\./g, '').replace(/(\s*)/g, "") // 일자 yyyyMMdd
            let limited = dateLimit.toLocaleDateString()
            // console.log('limited', limited)
            const changed = []
            const final = []
            if(limited.includes('.')){
                const splited = limited.split('.')
                if(splited.indexOf('') !== -1) splited.splice(splited.indexOf(''))
                // console.log('splited', splited)
                splited.forEach(e => {
                    changed.push(e.trim())
                });
            }
            if(changed && changed.length > 0){
                changed.forEach(e => {
                    if(e.length === 1){
                        e = '0'+e
                    }
                    final.push(e)
                });
            // console.log('final', final)
            }
            limited = final.join('')
            console.log('limited', limited)

            return limited
        },

        // 22.04.15 suye 컨텐츠 필터링 함수로 따로 뺌 
        contentDataFilter(){
            const co = '' + this.conData.content
            // 20210831 shb
            // 가져오는 데이터의 style 상위 요소에 적용되어 style 제거 | 해당 관련 style 은 resHtml.css 파일에 정의 되어있음
            // this.conData.content = co.replace(/<style>((.|\n)*?)<\/style>/g, '')
            // alert(co.replace(/<style>.*<\/style>/g, ''))
            // 20211022 shb 줄바꿈 적용안되어 추가
            this.conData.content = co
                .replace(/<style>((.|\n)*?)<\/style>/g, '')
                .replace(/&lt;br&gt;/g, '<br/>')
            console.log('content: ', this.conData.content)
        },

        contentDfilter() {
            /* 
                220322 meej conDate[0] 있는경우 \n -> <br/> 처리
            */
            if(this.conData[0] !== undefined){
                // 20220407 kangwook 엔터많아서
                // 22.05.10 suye 메뉴에 따른 과도한 줄바꿈 수정 
                if(this.conData[0].newsType1 === 'MARKET_AFTER_ISSUE' || this.conData[0].newsType1 === 'MARKET_BEFORE_ISSUE'){ // 일간 뉴스 클리핑 
                    this.conData[0].content = this.conData[0].content.replaceAll('\n', '<br/>').replaceAll('<br /><br/><br /><br/>', '<br><br>')
                } else if(this.conData[0].newsType1 === 'MARKET_HIGH_COMMENT'){ // 급등락 종목 사유 분석
                    this.conData[0].content = this.conData[0].content.replaceAll('\n', '<br/>').replaceAll('<br /><br/>', '<br>').replaceAll('<br><br><br>', '<br>')
                } else if(this.conData[0].newsType1 === 'MARKET_FLASH_AM_FEATURED_KOSDAQ' 
                            || this.conData[0].newsType1 === 'MARKET_FLASH_AM_FEATURED_KOSPI' 
                            || this.conData[0].newsType1 === 'MARKET_FLASH_PM_FEATURED_KOSPI' 
                            || this.conData[0].newsType1 === 'MARKET_FLASH_PM_FEATURED_KOSDAQ' 
                            || this.conData[0].newsType1 === 'MARKET_FLASH_THEME_AM' 
                            || this.conData[0].newsType1 === 'MARKET_FLASH_THEME_PM' 
                    ){
                    /* 
                        220516 meej 장중 특징주 및 특징테마 추가 
                    */
                    const co = '' + this.conData[0].content
                    this.conData[0].content = co
                        .replace(/<style>((.|\n)*?)<\/style>/g, '')
                        .replace(/&lt;br&gt;/g, '<br/>')
                } else {
                    this.conData[0].content = this.conData[0].content.replaceAll('\n', '<br/>')
                }
               
            }else{
                this.contentDataFilter()
            }
        },
    },
}
